import React, { useEffect } from "react";
import { Switch, Route, useHistory } from "react-router-dom";

import Loading from "src/Shared/Components/Loading";
import { applyPrimaryColor } from "src/Shared/Utils/HTMLUtils";
import { lazyWithRetry } from "src/Shared/Utils/lazyWithRetry";
import {
  LOGIN_ROUTE_PATH,
  LOGIN_OTP_ROUTE_PATH,
  NOT_AUTHENTICATED_ROUTE_NAME,
  REGISTER_ROUTE_PATH,
} from "./AppNavUrls.constant";

const AnonymousRoute = lazyWithRetry(() => import("./AnonymousRoute"));
const OTP = lazyWithRetry(
  () => import("src/Commons/Auth/Login/Components/OTP"),
);
const Login = lazyWithRetry(() => import("src/Commons/Auth/Login"));
const Register = lazyWithRetry(() => import("src/Commons/Auth/Register"));

const MainRoute: React.FC = () => {
  const { push, location } = useHistory();

  useEffect(() => {
    applyPrimaryColor();
    if (location.pathname === "/") {
      push(LOGIN_ROUTE_PATH);
    }
  }, []);

  return (
    <React.Suspense fallback={<Loading />}>
      <Switch>
        <Route
          path={`/${NOT_AUTHENTICATED_ROUTE_NAME}`}
          component={AnonymousRoute}
        />
        <Route exact path={REGISTER_ROUTE_PATH} component={Register} />

        <Route exact path={LOGIN_ROUTE_PATH} component={Login} />
        <Route exact path={LOGIN_OTP_ROUTE_PATH} component={OTP} />
      </Switch>
    </React.Suspense>
  );
};
export default MainRoute;
